import styled, { createGlobalStyle } from 'styled-components'
import { colors } from 'web-makeup/dist/design-system/config/data/theme'

import { MIDLARGE_MAX_BREAKPOINT, MID_BREAKPOINT, XSMALL_BREAKPOINT } from '../../../../style'

export const AntModalStyles = createGlobalStyle`
  .ant-modal-body.ant-modal-body {
    padding: 1.5rem 2.25rem;
  }
  .ant-select-dropdown-menu-item:hover {
    && {
      background: ${colors.adaptBlue};
      color: white;
    }
  }

  .ant-modal-close {
    span {
      display: none;
    }

    &::after {
      content: "";
      background: url(https://res.cloudinary.com/ninety-seconds/image/upload/v1645338848/-design-system/button-close-light.svg) no-repeat center;
      width:2.25rem;
      height:2.25rem;
      top: 0.75rem;
      right: 0.75rem;
      position: absolute;
    }
  }

  .ant-modal {
    max-width: 100%;
  }

  .ant-modal-footer.ant-modal-footer.ant-modal-footer {
    background: rgba(255, 255, 255, 0.9);
    border: 1px solid ${colors.gandalf};
    box-shadow: 0 2px 16px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(16px);
    padding: 0.75rem 2.25rem;
  }

  .ant-modal-content.ant-modal-content.ant-modal-content {
    border-radius: 1.25rem;
    overflow: hidden;
  }

  .ant-modal-footer.ant-modal-footer.ant-modal-footer {
    border-bottom-left-radius: 1.25rem;
    border-bottom-right-radius: 1.25rem;
  }
`
export const Tab = styled.div<{ active?: boolean }>`
  background: ${({ active }) => (active ? colors.nebula : colors.gandalf)};
  border-radius: 0.75rem;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 160px;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  color: ${({ active }) => (active ? colors.white : colors.black1)};

  img {
    display: block;
    margin: 0 auto 0.75rem;
    max-width: 3rem;
  }
`
export const Content = styled.div`
  min-height: 100vh;
  max-width: 100%;
  padding: 0;
  margin: 0 auto;

  .sub-brand-card {
    max-width: 29.69rem;
  }
`

export const SubbrandsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 1.5rem;
  margin-bottom: 1.5rem;

  @media all and (max-width: ${MIDLARGE_MAX_BREAKPOINT}) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media all and (max-width: ${MID_BREAKPOINT}) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media all and (max-width: ${XSMALL_BREAKPOINT}) {
    grid-template-columns: 1fr;
  }

  > div {
    min-width: 0;
  }
`
export const SectionTitle = styled.h3`
  color: ${colors.black1};
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.625rem;
  margin-bottom: 0.75rem;
`
export const DepartmentWrapper = styled.div`
  max-height: 26rem;
  position: relative;
  overflow-y: scroll;

  &::after,
  &::before {
    content: '';
    opacity: 0;
    transition: all 0.2s ease;
  }

  &.bottom {
    &::before {
      content: '';
      background: linear-gradient(180deg, white 0%, rgba(255, 255, 255, 0) 100%);
      background-repeat: no-repeat;
      width: 100%;
      height: 100px;
      position: absolute;
      left: 0;
      top: 7rem;
      z-index: 11;
      opacity: 1;
    }
  }

  &.top {
    &::after {
      content: '';
      background: linear-gradient(0deg, white 0%, rgba(255, 255, 255, 0) 100%);
      background-repeat: no-repeat;
      width: 100%;
      height: 100px;
      position: absolute;
      left: 0;
      bottom: 0;
      z-index: 11;
      opacity: 1;
    }
  }

  & {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
  &::-webkit-scrollbar {
    display: none;
  }
`



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/BrandDashboardSubBrands/SubBrands/SubBrands.style.tsx